import * as Contractor from '../schemas/inductions/CDU/Contractor.json'

export default {
    type: 'CDU Induction',
    schemas: {
        'CDU Contractor': Contractor,
    }
}